import Axios from "axios";
import {
  SET_DAY_BOOK_REPORT,
  UNSET_DAY_BOOK_REPORT,
} from "@/store/mutation-types";
import {
  getDayBookReport,
} from "@/store/api";

const state = {
  dayBookReport: [],
};

const getters = {
  getDayBookReport(state) {
    return state.dayBookReport;
  },
};

const mutations = {
  [SET_DAY_BOOK_REPORT](state, data) {
    state.dayBookReport = data;
  },
  [UNSET_DAY_BOOK_REPORT](state) {
    state.dayBookReport = [];
  },
};

const actions = {
  getDayBook({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getDayBookReport}`, { params: data })
        .then((response) => {
          commit(SET_DAY_BOOK_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_DAY_BOOK_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

